import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Icons, Table } from '@/js/libs/ui/src/V2';

import type { ColumnProps } from '../../types';

export const ArchivedActionsCell: React.FC<ColumnProps> = React.memo(function ArchivedActionsCell({ item, restoreModalState }) {
  const handleRestore = useCallbackRef(() => {
    if (item.id) {
      restoreModalState?.open(item.id);
    }
  });

  return (
    <Table.ActionButton onClick={handleRestore}>
      <Icons.Reload />
    </Table.ActionButton>
  );
});
